import React, { memo, useRef, useEffect } from 'react';
const PdfRenderer = (props) => {
    const { pdfPage, scale = 1 } = props;
    const pdfCanvasRef = useRef(null);
    const isRendering = useRef(false);
    useEffect(() => {
        if (isRendering.current) {
            return;
        }
        // Prevents re-rendering when another operation is in progress
        isRendering.current = true;
        const canvas = pdfCanvasRef.current;
        const canvasContext = canvas.getContext('2d');
        const viewport = pdfPage.getViewport({
            offsetX: 0,
            offsetY: 0,
            scale,
            rotation: 0,
        });
        canvas.width = Math.floor(viewport.width);
        canvas.height = Math.floor(viewport.height);
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
        canvasContext.beginPath();
        const renderContext = {
            canvasContext,
            viewport,
        };
        const renderTask = pdfPage.render(renderContext);
        renderTask.promise.then(() => {
            isRendering.current = false;
        });
    }, [pdfPage, scale]);
    return React.createElement("canvas", { ref: pdfCanvasRef, "data-testid": "pdf-viewer-canvas" });
};
export default memo(PdfRenderer);
